import { ACCESS_TOKEN_KEY } from '@/shared/constants'
import { setCookie } from 'nookies'

export const fallbackDomain = process.env.NEXT_PUBLIC_APP_DOMAIN || 'localhost'
export const isProduction = process.env.NEXT_PUBLIC_ENVIROMENT === 'production'
export const isDevelopment =
  process.env.NEXT_PUBLIC_ENVIROMENT === 'development'

export function setTokenOnCookies(token: string) {
  const cookieOptions = {
    maxAge: 30 * 24 * 60 * 60, // 30 dias
    path: '/',
    domain: fallbackDomain,
    secure: isProduction,
    httpOnly: false,
    sameSite: 'Strict' as const,
  }

  // Se for desenvolvimento, criar outro cookie com o domínio localhost
  if (isDevelopment) {
    setCookie(null, ACCESS_TOKEN_KEY, token, {
      ...cookieOptions,
      domain: 'localhost',
    })
  }

  setCookie(null, ACCESS_TOKEN_KEY, token, cookieOptions)
}
